export default "__VITE_ASSET__GnyXw0fg__"